// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"9c5b6a5b","228":"c8a705d2","294":"476e0d17","358":"c52ca2a8","379":"b19ed097","401":"e18e1e79","453":"841296c2","487":"dda90760","524":"16c74546","696":"5af62962","790":"04fb2e4b","871":"90e4f80d","929":"c1287e99","945":"05ba0058"}[chunkId] + ".chunk.js";
};